import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  Scale,
  ScaleInput,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { requiredNumber } from "~/utils/validations";

type Values = {
  howOptimistic: Scale | undefined;
};

const validationSchema = Yup.object({
  howOptimistic: requiredNumber,
});

export const HowOptimisticPage: FC = () => {
  const { t } = useTranslation();
  const { howOptimistic } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const initialValues: Values = {
    howOptimistic: howOptimistic || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt question={t("onboarding.howOptimisticPage.question")} />

          <ScaleInput
            autoAdvance
            defaultValue={howOptimistic}
            id="howOptimistic"
            scalePath="onboarding.howOptimisticPage"
          />
        </QuestionContainer>

        <NextButton showButton={!!howOptimistic} />
      </FormContainer>
    </QuestionPageContainer>
  );
};
